import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0F1C] text-white/60 font-display tracking-widest">
      LOADING…
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  // Force password change flow — allow only /app/change-password when flag is set
  if (user.must_change_password && location.pathname !== "/app/change-password") {
    return <Navigate to="/app/change-password" replace />;
  }
  if (adminOnly && user.role !== "admin") return <Navigate to="/app/pitches" replace />;
  return children;
}
